'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _INT_TWO = require('./_constants/INT_TWO');

var _INT_TWO2 = _interopRequireDefault(_INT_TWO);

var _add = require('./add');

var _add2 = _interopRequireDefault(_add);

var _define = require('./define');

var _define2 = _interopRequireDefault(_define);

var _executeWith = require('./executeWith');

var _executeWith2 = _interopRequireDefault(_executeWith);

var _toString = require('./toString');

var _toString2 = _interopRequireDefault(_toString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pre = (0, _executeWith2.default)(_add2.default, _toString2.default, _toString2.default); /**
                                                                                              * Append string to the end of another string
                                                                                              *
                                                                                              * @module appendTo
                                                                                              * @func
                                                                                              * @since 1.13.0
                                                                                              * @param {string} str
                                                                                              * @param {string} append
                                                                                              * @returns {function|string}
                                                                                              * @example
                                                                                              *
                                                                                              *     appendTo('foo', 'bar'); //=> 'foobar'
                                                                                              *     appendTo('bar')('baz'); //=> 'barbaz'
                                                                                              */

var appendTo = (0, _define2.default)(pre, _INT_TWO2.default);

exports.default = appendTo;